import React from "react";
import { Box, styled } from "@mui/material";
import { BellIcon } from "../../../icons/bell-icon";

// Custom styled components using MUI
const ButtonContainer = styled(Box)(({ theme }) => ({
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    marginTop: "10px",
    display: "flex",
    alignItems: "center",
  },
}));

const StyledBellIcon = styled(BellIcon)({
  marginLeft: "15px",
});

export const NotificationsButton = ({ 
  notificationsCount, 
  onClick,
  size = 17 
}) => {
  return (
    <ButtonContainer>
      <StyledBellIcon
        notificationsCount={notificationsCount}
        onClick={onClick}
        size={size}
      />
    </ButtonContainer>
  );
};
